"use strict";

define('rs/models/download',['rs/models/abstract', 'jquery', 'underscore'], function (AbstractModel, $, _) {
  var DownloadGenerator = AbstractModel.extend({}, {
    requestDownload: function requestDownload(formData, options) {
      var externalWindow = options.externalWindow,
        windoc = externalWindow ? externalWindow.document : window.document,
        form = windoc.createElement("form"),
        data = formData || {},
        url = options.url;
      if (externalWindow) {
        url = window.location.protocol + "//" + window.location.host + options.url;
      }
      data['_csrf'] = window._csrf_token;
      form.setAttribute("accept-charset", 'UTF-8');
      form.setAttribute("action", url);
      form.setAttribute("method", options.method || "POST");
      form.setAttribute("target", externalWindow ? "_self" : "_blank");
      for (key in data) {
        var element = windoc.createElement("input");
        element.setAttribute("type", "hidden");
        element.setAttribute("name", key);
        element.setAttribute("value", data[key]);
        form.appendChild(element);
      }
      var submitEl = windoc.createElement('input');
      submitEl.setAttribute('type', 'submit');
      submitEl.setAttribute('value', 'Submit');
      form.appendChild(submitEl);
      windoc.body.appendChild(form);
      $(form).trigger('submit');
      windoc.body.removeChild(form);
    },
    generatePopup: function generatePopup() {
      var wi = window.open('about:blank', '_blank');
      wi.document.title = "Loading...";
      wi.document.body.innerHTML = "<pre>Loading...</pre>";
      return wi;
    }
  });
  return DownloadGenerator;
});

